import { defaultDescription, CashLoanMeta } from "src/data/DataMetatags";
import { defBreadcrumb } from "src/data/DataBreadcrumb";
import HomePage from "src/components/CashLoan/HomePage";
import Layout from "src/components/Layout";
import NextHead from "src/components/Seo/NextHead";

const CashLoan = ({ title, description, path, breadcrumb }) => {
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <HomePage />
    </Layout>
  );
};

CashLoan.getInitialProps = ({ query }) => {
  const { title, path } = CashLoanMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];
  return {
    title: "Pembiayaan Tunai",
    description: defaultDescription,
    query,
    path,
    breadcrumb
  };
};

export default CashLoan;
